import React, {useEffect, useState} from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import AccessTimeOutlinedIcon from '@material-ui/icons/AccessTimeOutlined';
import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined';
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';
import moment from 'moment';
import Mesa from '../../../reunioesRegister/reuniaoAbas/reuniaoMesa';
import UseStyles from '../../../useStyles';
import {getById} from '../../../../../services/reuniao/ReuniaoService';

const AbaSobreVisualizar = (props) => {
  const classes = UseStyles();

  const { id } = props;

  const initialState = {
    id: id,
    usuariosConvidados: [],
    mesa: {
      cadeira1: '',
      cadeira2: '',
      cadeira3: '',
      cadeira4: '',
      cadeira5: '',
      cadeira6: '',
      cadeira7: '',
      cadeira8: '',
      cadeira9: '',
      cadeira10: '',
      cadeira11: '',
      cadeira12: '',
      cadeira13: '',
      cadeira14: '',
      cadeira15: '',
      cadeira16: '',
      cadeira17: '',
    },
  }

  const [reuniao, setReuniao] = useState({});

  const [dadosMesa, setDadosMesa] = useState(initialState);

  const relacaoDias = {
    0: 'Domingo',
    1: 'Segunda-feira',
    2: 'Terça-feira',
    3: 'Quarta-feira',
    4: 'Quinta-feira',
    5: 'Sexta-feira',
    6: 'Sabado',
  }

  const getDia = (stringData) => {
    const data = moment(stringData, 'YYYY-MM-DDTHH:mm:ss');
    return `${relacaoDias[data.day()]}, ${data.format('DD/MM/YYYY')}`;
  }

  const getHora = (stringData) => {
    const data = moment(stringData, 'YYYY-MM-DDTHH:mm:ss');
    const hour = moment(data.hour(), 'hours').format('HH')
    const minutes = moment(data.minute(), 'minutes').format('mm')
    return `${hour}h${minutes}`;
  }

  useEffect(() => {
    getById(id).then((response) => {
      if (response && response.status === 200) {
        const {data} = response;
        setDadosMesa({ ...dadosMesa, id: data.id });
        setReuniao(data);
      }
    })
  }, [])

  return (
    <>
      <div style={{ borderBottom: '1px solid #dfdfe6', paddingBottom: 24 }}>
        <Grid container spacing={4}>
          <Grid item md={6} xs={12}>
            <div className={classes.infoAbaSobreReuniao}>
              {reuniao.descricao}
            </div>
          </Grid>
          <Grid item md={6} xs={12}>
            <div className={classes.cardInfoAbaSobre}>
              <Typography
                className={classes.cardInfoAbaSobrePeriodicidade}
                style={{ marginBottom: 24 }}
              >
                {reuniao.edicao}
                °
                {reuniao.periodicidade}
              </Typography>
              <Typography
                className={classes.cardInfoAbaSobreExtra}
                style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}
              >
                <CalendarTodayOutlinedIcon
                  style={{ marginRight: 12, color: '#5e5e85' }}
                />
                {' '}
                {getDia(reuniao.data)}
              </Typography>
              <Typography
                className={classes.cardInfoAbaSobreExtra}
                style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}
              >
                <AccessTimeOutlinedIcon
                  style={{ marginRight: 12, color: '#5e5e85' }}
                />
                {getHora(reuniao.data)}
              </Typography>
              <Typography
                className={classes.cardInfoAbaSobreExtra}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <RoomOutlinedIcon
                  style={{ marginRight: 12, color: '#5e5e85' }}
                />
                {reuniao.endereco}
                ,
                {' '}
                {reuniao.cidade}
                {' '}
                /
                {' '}
                {reuniao.estado}
              </Typography>
            </div>
          </Grid>
        </Grid>
      </div>
      <div style={{ paddingTop: 24 }}>
        <Mesa isVisualizar dados={dadosMesa} updateDados={setDadosMesa} />
      </div>
    </>
  );
}

export default AbaSobreVisualizar;
